// extracted by mini-css-extract-plugin
export default {"root":"eight_root__fzFMy","top":"eight_top__111FE","title":"eight_title__jr4E2","description":"eight_description__kz7mS","bottom":"eight_bottom__+6dua"};